import React from "react";
import { Reveal } from "@/components/motion/Reveal";
import { Eyebrow } from "@/components/kit";

const stats = [
  { v: "120+", l: "Ondernemers geholpen" },
  { v: "4.8/5", l: "Gemiddelde Google-score" },
  { v: "3–8×", l: "Gemiddelde ROAS" },
  { v: "24u", l: "Reactietijd" },
];

const StatsBand = () => (
  <section
    data-testid="stats-band"
    className="relative bg-obsidian overflow-hidden py-20 lg:py-28"
  >
    <div className="absolute inset-0 grid-dark opacity-60" />
    <div className="glow-orb w-[520px] h-[520px] bg-electric/20 top-1/2 -translate-y-1/2 -right-40" />

    <div className="relative max-w-[1400px] mx-auto px-6 lg:px-12">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-5">
          <Eyebrow dark>Waarom UPPIT · De cijfers</Eyebrow>
          <h2 className="mt-6 font-display font-black text-ivory tracking-tight leading-[0.95] text-4xl sm:text-5xl">
            Marketing die je kunt <span className="text-gradient-blue">meten.</span>
          </h2>
          <p className="mt-5 max-w-md text-white/60 leading-relaxed">
            Geen vage rapportages of vanity metrics. Wij sturen op wat telt:
            leads, omzet en rendement — elke maand transparant in beeld.
          </p>
        </div>

        <div className="lg:col-span-7">
          <div className="grid grid-cols-2 gap-px bg-white/10 rounded-2xl overflow-hidden border border-white/10">
            {stats.map((s, i) => (
              <Reveal key={i} delay={i * 0.08} className="bg-obsidian px-6 lg:px-9 py-8 lg:py-10">
                <div className="font-display font-black text-5xl lg:text-6xl text-ivory leading-none mb-2">
                  {s.v}
                </div>
                <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-white/45">
                  {s.l}
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default StatsBand;
